export const last_addresses = [
    {
        "title": "г. Москва, Ленинградское шоссе, д. 71Г",
        "coord": [
            55.875758,
            37.447288
        ],
        "descr": "г. Москва, Ленинградское шоссе, д. 71Г"
    },
    {
        "title": "г. Москва, просп. Мира, д. 211, корп. 1",
        "coord": [
            55.844041,
            37.662650
        ],
        "descr": "г. Москва, просп. Мира, д. 211, корп. 1"
    },
    {
        "title": "г. Москва, ул. Дорожная, д.1, корп. 1",
        "coord": [
            55.630721,
            37.624930
        ],
        "descr": "г. Москва, ул. Дорожная, д.1, корп. 1"
    },
    {
        "title": "г. Москва, ул. Рябиновая, д. 59",
        "coord": [
            55.685878,
            37.431828
        ],
        "descr": "г. Москва, ул. Рябиновая, д. 59"
    },
    {
        "title": "г. Москва, Дмитровское шоссе, д. 165Б",
        "coord": [
            55.915997,
            37.540084
        ],
        "descr": "г. Москва, Дмитровское шоссе, д. 165Б"
    },
    {
        "title": "г. Санкт-Петербург, Комендантский проспект, д.3, лит. А",
        "coord": [
            60.002207,
            30.268635
        ],
        "descr": "г. Санкт-Петербург, Комендантский проспект, д.3, лит. А"
    },
    {
        "title": "г. Санкт-Петербург, проспект Косыгина, д.4, лит. А",
        "coord": [
            59.940835,
            30.456176
        ],
        "descr": "г. Санкт-Петербург, проспект Косыгина, д.4, лит. А"
    },
    {
        "title": "г. Москва, ул. Маршала Прошлякова, 14",
        "coord": [
            55.791187,
            37.388718
        ],
        "descr": "г. Москва, ул. Маршала Прошлякова, 14"
    },
    {
        "title": "г. Москва, МКАД, 104 км, д. 6",
        "coord": [
            55.811290,
            37.837453
        ],
        "descr": "г. Москва, МКАД, 104 км, д. 6"
    },
    {
        "title": "г. Москва, ул. Шоссейная, д. 2Б",
        "coord": [
            55.700679,
            37.726331
        ],
        "descr": "г. Москва, ул. Шоссейная, д. 2Б"
    },
    {
        "title": "г. Санкт-Петербург, Пулковское шоссе, д. 23, лит. А",
        "coord": [
            59.822440,
            30.316380
        ],
        "descr": "г. Санкт-Петербург, Пулковское шоссе, д. 23, лит. А"
    },
    {
        "title": "г. Нижний Новгород, Мещерский бульвар, д. 3а",
        "coord": [
            56.334298,
            43.951243
        ],
        "descr": "г. Нижний Новгород, Мещерский бульвар, д. 3а"
    },
    {
        "title": "Ярославская обл., г. Ярославль, просп. Фрунзе, д. 32",
        "coord": [
            57.590021,
            39.897622
        ],
        "descr": "Ярославская обл., г. Ярославль, просп. Фрунзе, д. 32"
    },
    {
        "title": "Республика Татарстан, г. Казань, ул. Вахитова, д. 4",
        "coord": [
            55.812312,
            49.081917
        ],
        "descr": "Республика Татарстан, г. Казань, ул. Вахитова, д. 4"
    },
    {
        "title": "г. Ростов-на-Дону, ул. Доватора, д. 255",
        "coord": [
            47.236336,
            39.606667
        ],
        "descr": "г. Ростов-на-Дону, ул. Доватора, д. 255"
    },
    {
        "title": "г. Воронеж, ул. Остужева, д. 56",
        "coord": [
            51.678599,
            39.284019
        ],
        "descr": "г. Воронеж, ул. Остужева, д. 56"
    },
    {
        "title": "г. Краснодар, Ростовское шоссе, д. 30",
        "coord": [
            45.097991,
            38.995884
        ],
        "descr": "г. Краснодар, Ростовское шоссе, д. 30"
    },
    {
        "title": "Республика Башкортостан, г.. Уфа, ул. Рубежная, д. 170",
        "coord": [
            54.668561,
            55.930888
        ],
        "descr": "Республика Башкортостан, г.. Уфа, ул. Рубежная, д. 170"
    },
    {
        "title": "г. Волгоград, ул. Историческая, д. 164",
        "coord": [
            48.771801,
            44.473748
        ],
        "descr": "г. Волгоград, ул. Историческая, д. 164"
    },
    {
        "title": "г. Екатеринбург, Дублер Сибирского тракта, д. 21",
        "coord": [
            56.824178,
            60.652559
        ],
        "descr": "г. Екатеринбург, Дублер Сибирского тракта, д. 21"
    },
    {
        "title": "г. Екатеринбург, ул. Металлургов, д. 85",
        "coord": [
            56.824306,
            60.511245
        ],
        "descr": "г. Екатеринбург, ул. Металлургов, д. 85"
    },
    {
        "title": "Челябинская обл., г. Копейск, пр. Победы, д. 76",
        "coord": [
            55.120738,
            61.548377
        ],
        "descr": "Челябинская обл., г. Копейск, пр. Победы, д. 76"
    },
    {
        "title": "г. Самара, 18 км Московского шоссе, д. 5а",
        "coord": [
            53.277863,
            50.277188
        ],
        "descr": "г. Самара, 18 км Московского шоссе, д. 5а"
    },
    {
        "title": "г. Тюмень, ул. Мельникайте, д. 141",
        "coord": [
            57.114283,
            65.543805
        ],
        "descr": "г. Тюмень, ул. Мельникайте, д. 141"
    },
    {
        "title": "Самарская обл., г. Тольятти, Южное шоссе, д. 2А",
        "coord": [
            53.547553,
            49.373699
        ],
        "descr": "Самарская обл., г. Тольятти, Южное шоссе, д. 2А"
    },
    {
        "title": "г. Пермь, шоссе Космонавтов, д. 393",
        "coord": [
            57.951498,
            56.120226
        ],
        "descr": "г. Пермь, шоссе Космонавтов, д. 393"
    },
    {
        "title": "г. Рязань, Московское шоссе, д. 25",
        "coord": [
            54.636121,
            39.680050
        ],
        "descr": "г. Рязань, Московское шоссе, д. 25"
    },
    {
        "title": "Тульская обл., Ленинский р-н, д. Прудное, д. 104",
        "coord": [
            54.155862,
            37.541871
        ],
        "descr": "Тульская обл., Ленинский р-н, д. Прудное, д. 104"
    },
    {
        "title": "г. Саратов, ул. Аэропорт, д. 14",
        "coord": [
            51.558403,
            46.038200
        ],
        "descr": "г. Саратов, ул. Аэропорт, д. 14"
    },
    {
        "title": "г. Липецк, ул. 50 лет НЛМК, д. 8",
        "coord": [
            52.587663,
            39.587973
        ],
        "descr": "г. Липецк, ул. 50 лет НЛМК, д. 8"
    },
    {
        "title": "г.Киров, ул.Московская, д.205",
        "coord": [
            58.600252,
            49.577437
        ],
        "descr": "г.Киров, ул.Московская, д.205"
    },
    {
        "title": "г. Ульяновск, ул. Урицкого, д. 100Д",
        "coord": [
            54.330218,
            48.354740
        ],
        "descr": "г. Ульяновск, ул. Урицкого, д. 100Д"
    },
    {
        "title": "г. Ставрополь, ул. Южный Обход, д.13",
        "coord": [
            44.989694,
            41.935217
        ],
        "descr": "г. Ставрополь, ул. Южный Обход, д.13"
    },
    {
        "title": "Республика Татарстан,  г. Набережные Челны, просп. Чулман, д. 33",
        "coord": [
            55.729062,
            52.371233
        ],
        "descr": "Республика Татарстан,  г. Набережные Челны, просп. Чулман, д. 33"
    },
    {
        "title": "г. Новосибирск, ул. Большевистская, д. 290",
        "coord": [
            54.976359,
            83.024221
        ],
        "descr": "г. Новосибирск, ул. Большевистская, д. 290"
    },
    {
        "title": "г. Омск, пр-кт Академика Королева, д.15, корп. 1",
        "coord": [
            55.037005,
            73.316451
        ],
        "descr": "г. Омск, пр-кт Академика Королева, д.15, корп. 1"
    },
    {
        "title": "Красноярский край, Емельяновский район, пос. Солонцы, пр. Котельникова, д. 1",
        "coord": [
            56.062660,
            92.841046
        ],
        "descr": "Красноярский край, Емельяновский район, пос. Солонцы, пр. Котельникова, д. 1"
    },
    {
        "title": "г. Оренбург, пр. Победы, д. 155",
        "coord": [
            51.815710,
            55.139158
        ],
        "descr": "г. Оренбург, пр. Победы, д. 155"
    },
    {
        "title": "Московская обл., г. Люберцы, пос. Томилино, 23-й км Новорязанского шоссе 23-й км, стр.17",
        "coord": [
            55.655386,
            37.906722
        ],
        "descr": "Московская обл., г. Люберцы, пос. Томилино, 23-й км Новорязанского шоссе 23-й км, стр.17"
    },
    {
        "title": "г. Москва, п. Московский, дер. Картмазово, стр. 7",
        "coord": [
            55.615644,
            37.389391
        ],
        "descr": "г. Москва, п. Московский, дер. Картмазово, стр. 7"
    },
    {
        "title": "г. Нижний Новгород, ул. Нартова, д. 4А",
        "coord": [
            56.286937,
            43.997839
        ],
        "descr": "г. Нижний Новгород, ул. Нартова, д. 4А"
    },
    {
        "title": "г. Курск, ул. Карла Маркса, д. 85",
        "coord": [
            51.791496,
            36.187706
        ],
        "descr": "г. Курск, ул. Карла Маркса, д. 85"
    },
    {
        "title": "Пензенская обл., Пензенский р-н, село Засечное, ул. Звездная, д.1",
        "coord": [
            53.143204,
            45.034629
        ],
        "descr": "Пензенская обл., Пензенский р-н, село Засечное, ул. Звездная, д.1"
    },
    {
        "title": "г. Ростов-на-Дону, пр. 40-лет Победы, д. 340",
        "coord": [
            47.245616,
            39.845035
        ],
        "descr": "г. Ростов-на-Дону, пр. 40-лет Победы, д. 340"
    },
    {
        "title": "г. Новокузнецк, Кондомское шоссе, д. 19",
        "coord": [
            53.734001,
            87.179315
        ],
        "descr": "г. Новокузнецк, Кондомское шоссе, д. 19"
    },
    {
        "title": "г. Калуга, Тульское шоссе, д. 51",
        "coord": [
            54.467187,
            36.252942
        ],
        "descr": "г. Калуга, Тульское шоссе, д. 51"
    },
    {
        "title": "г.Брянск, Фокинский район, проспект Московский, 1Д",
        "coord": [
            53.222762,
            34.381311
        ],
        "descr": "г.Брянск, Фокинский район, проспект Московский, 1Д"
    },
    {
        "title": "Алтайский край, г. Барнаул, Павловский тракт, д. 309",
        "coord": [
            53.345398,
            83.642486
        ],
        "descr": "Алтайский край, г. Барнаул, Павловский тракт, д. 309"
    },
    {
        "title": "г. Астрахань, ул. Заводская, д. 54 / ул. Набережная реки Царева, д. 83 ",
        "coord": [
            46.319812,
            48.019228
        ],
        "descr": "г. Астрахань, ул. Заводская, д. 54 / ул. Набережная реки Царева, д. 83 "
    },
    {
        "title": "Ивановская область, Ивановский район, южнее д. Игнатово, строен. 1",
        "coord": [
            56.950428,
            40.954427
        ],
        "descr": "Ивановская область, Ивановский район, южнее д. Игнатово, строен. 1"
    },
    {
        "title": "г.Новосибирск, Заельцовский район, ул.Северная, д.11",
        "coord": [
            55.070510,
            82.913297
        ],
        "descr": "г.Новосибирск, Заельцовский район, ул.Северная, д.11"
    },
    {
        "title": "Московская область, Солнечногорский р-н, д. Черная Грязь, ул. Торгово-Промышленная, д.5 (с.п. Луневское)",
        "coord": [
            55.980785,
            37.298437
        ],
        "descr": "Московская область, Солнечногорский р-н, д. Черная Грязь, ул. Торгово-Промышленная, д.5 (с.п. Луневское)"
    },
    {
        "title": "г. Тверь, ул. Склизкова, д. 122",
        "coord": [
            56.829468,
            35.946463
        ],
        "descr": "г. Тверь, ул. Склизкова, д. 122"
    },
    {
        "title": "Свердловская область, г.Екатеринбург, проспект Космонавтов, д. 102а",
        "coord": [
            56.913185,
            60.614578
        ],
        "descr": "Свердловская область, г.Екатеринбург, проспект Космонавтов, д. 102а"
    },
    {
        "title": "г. Томск, ул. Клюева, д. 44",
        "coord": [
            56.494634,
            85.041568
        ],
        "descr": "г. Томск, ул. Клюева, д. 44"
    },
    {
        "title": "Московская обл., мкр.Железнодорожный, ул.Советская, д.60",
        "coord": [
            55.750023,
            38.046195
        ],
        "descr": "Московская обл., мкр.Железнодорожный, ул.Советская, д.60"
    },
    {
        "title": "г. Калининград, Московский проспект, д. 279",
        "coord": [
            54.706459,
            20.593492
        ],
        "descr": "г. Калининград, Московский проспект, д. 279"
    },
    {
        "title": "г. Смоленск, ул. Кутузова, д. 54",
        "coord": [
            54.840505,
            32.043077
        ],
        "descr": "г. Смоленск, ул. Кутузова, д. 54"
    },
    {
        "title": "Чувашская республика, г. Чебоксары,  шоссе Марпосадское, 15/2",
        "coord": [
            56.129514,
            47.318910
        ],
        "descr": "Чувашская республика, г. Чебоксары,  шоссе Марпосадское, 15/2"
    },
    {
        "title": "Удмуртская республика, г. Ижевск, ул. Союзная, д. 6",
        "coord": [
            56.846543,
            53.307556
        ],
        "descr": "Удмуртская республика, г. Ижевск, ул. Союзная, д. 6"
    },
    {
        "title": "Республика Адыгея, Тахтамукайский район, а. Новая Адыгея, ул. Тургеневское шоссе, 27/2",
        "coord": [
            45.017264,
            38.932320
        ],
        "descr": "Республика Адыгея, Тахтамукайский район, а. Новая Адыгея, ул. Тургеневское шоссе, 27/2"
    },
    {
        "title": "Республика Татарстан, г. Казань, Приволжский район, ул. Тихорецкая, д. 4",
        "coord": [
            55.732241,
            49.130983
        ],
        "descr": "Республика Татарстан, г. Казань, Приволжский район, ул. Тихорецкая, д. 4"
    },
    {
        "title": "г. Кемерово, ул. Волгоградская, д. 58",
        "coord": [
            55.323930,
            86.171720
        ],
        "descr": "г. Кемерово, ул. Волгоградская, д. 58"
    },
    {
        "title": "Челябинская область, г. Магнитогорск, ул. 50-летия Магнитки, 69",
        "coord": [
            53.354734,
            58.950773
        ],
        "descr": "Челябинская область, г. Магнитогорск, ул. 50-летия Магнитки, 69"
    },
    {
        "title": "Ставропольский край, г. Пятигорск, Бештаугорское шоссе, д. 94",
        "coord": [
            44.061739,
            43.018522
        ],
        "descr": "Ставропольский край, г. Пятигорск, Бештаугорское шоссе, д. 94"
    },
    {
        "title": "Иркутская область, г. Иркутск, ул. Розы Люксембург, 365",
        "coord": [
            52.360085,
            104.136256
        ],
        "descr": "Иркутская область, г. Иркутск, ул. Розы Люксембург, 365"
    },
    {
        "title": "Красноярский край, г.Красноярск, ул. Кутузова, 1, строение 196",
        "coord": [
            55.990403,
            92.982082
        ],
        "descr": "Красноярский край, г.Красноярск, ул. Кутузова, 1, строение 196"
    },
    {
        "title": "Вологодская обл., г.Вологда, Окружное шоссе, д. 11а",
        "coord": [
            59.206715,
            39.811959
        ],
        "descr": "Вологодская обл., г.Вологда, Окружное шоссе, д. 11а"
    },
    {
        "title": "Волгоградская область, г. Волжский, проспект им. Ленина, 2г",
        "coord": [
            48.811835,
            44.728151
        ],
        "descr": "Волгоградская область, г. Волжский, проспект им. Ленина, 2г"
    },
    {
        "title": "Самарская область, г. Самара, ул. Уральская, 225",
        "coord": [
            53.133411,
            50.138533
        ],
        "descr": "Самарская область, г. Самара, ул. Уральская, 225"
    },
    {
        "title": "Московская область, г. Серпухов, г.о. Серпухов, бульвар 65 лет Победы, 4",
        "coord": [
            54.943959,
            37.402929
        ],
        "descr": "Московская область, г. Серпухов, г.о. Серпухов, бульвар 65 лет Победы, 4"
    },
    {
        "title": "г. Омск, Черлакский тракт, д. 5",
        "coord": [
            54.896516,
            73.429477
        ],
        "descr": "г. Омск, Черлакский тракт, д. 5"
    },
    {
        "title": "Московская область, г. Котельники, городской округ Котельники, Новорязанское ш., д. 5",
        "coord": [
            55.668376,
            37.865813
        ],
        "descr": "Московская область, г. Котельники, городской округ Котельники, Новорязанское ш., д. 5"
    },
    {
        "title": "Московская область, Богородский городской округ, дер. Новые Псарьки, ул. Парковая, д. 4.",
        "coord": [
            55.831443,
            38.368753
        ],
        "descr": "Московская область, Богородский городской округ, дер. Новые Псарьки, ул. Парковая, д. 4."
    },
    {
        "title": "г. Москва, Складочная ул. 1,стр.  1",
        "coord": [
            55.800453,
            37.594584
        ],
        "descr": "г. Москва, Складочная ул. 1,стр.  1"
    },
    {
        "title": "г. Владимир, Московское ш., 6Б",
        "coord": [
            56.113381,
            40.325265
        ],
        "descr": "г. Владимир, Московское ш., 6Б"
    },
    {
        "title": "Воронежская область, Семилукский район, г. Семилуки, ул. Заречная-2, 52 М",
        "coord": [
            51.653439,
            39.062036
        ],
        "descr": "Воронежская область, Семилукский район, г. Семилуки, ул. Заречная-2, 52 М"
    },
    {
        "title": "Московская область, городской округ Подольск, г. Подольск, 42-й км автомагистрали М-2 'Крым', 1, стр.1",
        "coord": [
            55.393165,
            37.601627
        ],
        "descr": "Московская область, городской округ Подольск, г. Подольск, 42-й км автомагистрали М-2 'Крым', 1, стр.1"
    },
    {
        "title": "г. Новосибирск, Северный проезд, 3 а",
        "coord": [
            54.950619,
            82.895843
        ],
        "descr": "г. Новосибирск, Северный проезд, 3 а"
    },
    {
        "title": "Краснодарский край, с. Гайдук, Новороссийское шоссе, 34",
        "coord": [
            44.772077,
            37.698960
        ],
        "descr": "Краснодарский край, с. Гайдук, Новороссийское шоссе, 34"
    },
    {
        "title": "еспублика Башкортостан, г. Стерлитамак, пр-т Ленина, 2м",
        "coord": [
            53.656291,
            55.944579
        ],
        "descr": "еспублика Башкортостан, г. Стерлитамак, пр-т Ленина, 2м"
    },
    {
        "title": "г. Москва, ул. 1-ая Дубровская, 13А, 1",
        "coord": [
            55.722801,
            37.674993
        ],
        "descr": "г. Москва, ул. 1-ая Дубровская, 13А, 1"
    },
    {
        "title": "Орловская область, г.Орел, ул.Раздольная, д.31",
        "coord": [
            53.007270,
            36.115535
        ],
        "descr": "Орловская область, г.Орел, ул.Раздольная, д.31"
    },
    {
        "title": "Московская область, городской округ Лобня, промзона ул. Горки Киовские, 15, 1, Б, 1, 1-98, 137-157",
        "coord": [
            56.025547,
            37.467742
        ],
        "descr": "Московская область, городской округ Лобня, промзона ул. Горки Киовские, 15, 1, Б, 1, 1-98, 137-157"
    },
    {
        "title": "Ростовская область, г. Ростов-на-Дону, пр-кт Королева, 1в",
        "coord": [
            47.284581,
            39.686716
        ],
        "descr": "Ростовская область, г. Ростов-на-Дону, пр-кт Королева, 1в"
    },
    {
        "title": "г. Сургут, улица 30 лет Победы, 76",
        "coord": [
            61.258071,
            73.460388
        ],
        "descr": "г. Сургут, улица 30 лет Победы, 76"
    },
    {
        "title": "Белгородская обл, Белгородский р-н, Дубовое п мкр. Пригородный, Придорожная ул, 2.",
        "coord": [
            50.552991,
            36.574592
        ],
        "descr": "Белгородская обл, Белгородский р-н, Дубовое п мкр. Пригородный, Придорожная ул, 2."
    },
    {
        "title": "Архангельская обл., г. Архангельск, Приморсский р-н, МО 'Талажское', Талажское ш., 22, стр. 31",
        "coord": [
            64.576197,
            40.590933
        ],
        "descr": "Архангельская обл., г. Архангельск, Приморсский р-н, МО 'Талажское', Талажское ш., 22, стр. 31"
    },
    {
        "title": "Свердловская область, г. Нижний Тагил, Свердловское шоссе, 65.",
        "coord": [
            57.858980,
            60.027278
        ],
        "descr": "Свердловская область, г. Нижний Тагил, Свердловское шоссе, 65."
    },
    {
        "title": "Респ. Северная Осетия – Алания, г. Владикавказ, Московское шоссе, 16.",
        "coord": [
            43.008012,
            44.648731
        ],
        "descr": "Респ. Северная Осетия – Алания, г. Владикавказ, Московское шоссе, 16."
    },
    {
        "title": "Московская область, Ленинский р-н, с/п Совхоз им. Ленина, пос. совхоза им.Ленина, 8",
        "coord": [
            55.574981,
            37.754952
        ],
        "descr": "Московская область, Ленинский р-н, с/п Совхоз им. Ленина, пос. совхоза им.Ленина, 8"
    },
    {
        "title": "г. Москва, Боровское шоссе, 10А",
        "coord": [
            55.653873,
            37.375701
        ],
        "descr": "г. Москва, Боровское шоссе, 10А"
    },
    {
        "title": "Московская область, Одинцовский р-н, СП Жаворонковское, д. Ликино, 35 км Минского шоссе, 2",
        "coord": [
            55.624932,
            37.144259
        ],
        "descr": "Московская область, Одинцовский р-н, СП Жаворонковское, д. Ликино, 35 км Минского шоссе, 2"
    },
    {
        "title": "Краснодарский край, городской окргу город Краснодар, г. Краснодар, Пашковский жилой массив территория, ул. Крылатая, 2 А.",
        "coord": [
            45.012064,
            39.127254
        ],
        "descr": "Краснодарский край, городской окргу город Краснодар, г. Краснодар, Пашковский жилой массив территория, ул. Крылатая, 2 А."
    }
]